import React from 'react';
import apiUrl from "../../enviroments/enviroment";
import axios from 'axios';

class CatPais extends React.Component {

    state = {
        paises: [],
    };


    componentDidMount() {
        this.peticion();
    }

    peticion  = async () => {
        axios.get(`${apiUrl.apiUrl}paises`, {
            headers: {
                userid: 'transexpress',
                pwduser: 'JTOYV9IlFarK6G2jPRo7dJxkmfHOhD9S',
            }
        }).then(res => {
            this.setState({paises: res.data});
        });
        console.log(this.state.paises);
    }

    render(){
        return(
            this.state.paises.map((gen) => <option  key={gen.id_pais} value={gen.id_pais}>{gen.descripcion}</option>)
        );
    }

}

export default CatPais;
